import { DoorOpen, AppWindow, Square, Bath, MoveHorizontal, Utensils } from "lucide-react";

// Map existing room.status -> floor-plan visual. `box` colors the whole card
// (used by the minimalist customer viewer); `dot`/`ring` used by the owner editor.
export const ROOM_PLAN_STATUS = {
  available: { dot: "bg-emerald-500", ring: "border-emerald-300", box: "bg-emerald-100 border-emerald-500 text-emerald-900", label: "Tersedia" },
  reserved: { dot: "bg-amber-400", ring: "border-amber-300", box: "bg-amber-100 border-amber-500 text-amber-900", label: "Akan tersedia" },
  occupied: { dot: "bg-rose-500", ring: "border-rose-300", box: "bg-rose-100 border-rose-500 text-rose-900", label: "Terisi" },
  maintenance: { dot: "bg-gray-400", ring: "border-border", box: "bg-gray-100 border-gray-400 text-gray-600", label: "Tidak tersedia" },
  inactive: { dot: "bg-gray-400", ring: "border-border", box: "bg-gray-100 border-gray-400 text-gray-600", label: "Tidak tersedia" },
};

export function planStatus(status) {
  return ROOM_PLAN_STATUS[status] || ROOM_PLAN_STATUS.inactive;
}

// Non-room elements the owner can drop onto the canvas.
export const ELEMENT_PALETTE = [
  { kind: "door", label: "Pintu", icon: DoorOpen, w: 70, h: 40 },
  { kind: "window", label: "Jendela", icon: AppWindow, w: 90, h: 32 },
  { kind: "kitchen", label: "Dapur", icon: Utensils, w: 120, h: 90 },
  { kind: "corridor", label: "Koridor", icon: MoveHorizontal, w: 260, h: 40 },
  { kind: "bathroom", label: "Kamar Mandi", icon: Bath, w: 90, h: 90 },
];

// Meta for rendering, incl. legacy "wall" so older saved plans still display.
const _LEGACY = [{ kind: "wall", label: "Dinding", icon: Square, w: 160, h: 24 }];

export const ELEMENT_META = [...ELEMENT_PALETTE, ..._LEGACY].reduce((acc, e) => {
  acc[e.kind] = e;
  return acc;
}, {});
